/**
 * Centralised data-testid definitions.
 * Kebab-case. Extend per feature module.
 */

export const PUBLIC = {
  homeScreen: "screen-home-publica",
  loginScreen: "screen-login",
  eventosSection: "public-eventos-section",
  ctaLogin: "public-cta-login",
  ctaEventos: "public-cta-eventos",
  inputSocio: "login-input-socio",
  inputPassword: "login-input-password",
  btnEntrar: "login-btn-entrar",
  linkOlvidePassword: "login-link-olvide-password",
};

export const APP_NAV = {
  inicio: "nav-inicio",
  misBoletos: "nav-mis-boletos",
  miPerfil: "nav-mi-perfil",
};

export const ADMIN_NAV = {
  dashboard: "admin-nav-dashboard",
  eventos: "admin-nav-eventos",
  usuarios: "admin-nav-usuarios",
  notificaciones: "admin-nav-notificaciones",
  bitacora: "admin-nav-bitacora",
  configuracion: "admin-nav-configuracion",
  reportes: "admin-nav-reportes",
  plantillasMesas: "admin-nav-plantillas-mesas",
};

export const ADMIN_MODULE_LABELS = {
  dashboard: "Dashboard",
  eventos: "Eventos",
  usuarios: "Usuarios",
  notificaciones: "Notificaciones",
  bitacora: "Bitácora",
  configuracion: "Configuración",
  reportes: "Reportes",
  plantillasMesas: "Plantillas de mesas",
};

export const ADMIN_AUTH = {
  screen: "screen-admin-login",
  inputUsuario: "admin-login-input-usuario",
  inputPassword: "admin-login-input-password",
  btnEntrar: "admin-login-btn-entrar",
  errorMsg: "admin-login-error",
};

export const ADMIN_DASHBOARD = {
  cardEventosProximos: "admin-dashboard-eventos-proximos",
  cardVentaActiva: "admin-dashboard-venta-activa",
  cardBoletosPendientes: "admin-dashboard-boletos-pendientes",
  cardAccesosHoy: "admin-dashboard-accesos-hoy",
  cardAlertas: "admin-dashboard-alertas",
  proximosList: "admin-dashboard-proximos-list",
  proximosItem: (id) => `admin-dashboard-proximo-${id}`,
};

export const EVENTOS_ADMIN = {
  screen: "screen-admin-eventos",
  btnNuevo: "eventos-btn-nuevo",
  search: "eventos-input-search",
  filtro: (id) => `eventos-filtro-${id}`,
  ordenFecha: "eventos-orden-fecha",
  table: "eventos-table",
  row: (id) => `eventos-row-${id}`,
  emptyState: "eventos-empty",
  rowActions: (id) => `eventos-row-actions-${id}`,
  actionEditar: (id) => `eventos-action-editar-${id}`,
  actionDuplicar: (id) => `eventos-action-duplicar-${id}`,
  actionPublicar: (id) => `eventos-action-publicar-${id}`,
  actionCancelar: (id) => `eventos-action-cancelar-${id}`,
  actionCerrar: (id) => `eventos-action-cerrar-${id}`,
  actionPausar: (id) => `eventos-action-pausar-${id}`,
  actionReanudar: (id) => `eventos-action-reanudar-${id}`,
  actionGestionMesas: (id) => `eventos-action-gestion-mesas-${id}`,
};

// Sprint 44.1 · Cambio de mesa desde Portal Admin
export const CAMBIO_MESA = {
  screen: "screen-admin-cambio-mesa",
  btnRegresar: "cambio-mesa-btn-regresar",
  btnRefrescar: "cambio-mesa-btn-refrescar",
  eventoNombre: "cambio-mesa-evento-nombre",
  comprasTable: "cambio-mesa-compras-table",
  comprasEmpty: "cambio-mesa-compras-empty",
  comprasError: "cambio-mesa-compras-error",
  compraRow: (id) => `cambio-mesa-compra-row-${id}`,
  compraCambiarBtn: (id) => `cambio-mesa-compra-cambiar-${id}`,
  ocupacionGrid: "cambio-mesa-ocupacion-grid",
  ocupacionMesa: (n) => `cambio-mesa-ocupacion-mesa-${n}`,
  // Diálogo
  dialog: "cambio-mesa-dialog",
  dialogMesaActual: "cambio-mesa-dialog-mesa-actual",
  dialogMesaSelect: "cambio-mesa-dialog-mesa-select",
  dialogMesaOption: (n) => `cambio-mesa-dialog-mesa-option-${n}`,
  dialogMotivo: "cambio-mesa-dialog-motivo",
  dialogConfirmar: "cambio-mesa-dialog-confirmar",
  dialogCancelar: "cambio-mesa-dialog-cancelar",
  dialogError: "cambio-mesa-dialog-error",
  dialogSinDestinos: "cambio-mesa-dialog-sin-destinos",
  dialogConfirmMesa: "cambio-mesa-dialog-confirm-mesa",
  dialogConfirmSi: "cambio-mesa-dialog-confirm-si",
  dialogConfirmNo: "cambio-mesa-dialog-confirm-no",
};

export const EVENTO_WIZARD = {
  screen: "screen-evento-wizard",
  stickyNav: "wizard-sticky-nav",
  stepIndicator: (n) => `wizard-step-${n}`,
  stepContent: (n) => `wizard-step-content-${n}`,
  fieldNombre: "wizard-field-nombre",
  fieldSubtitulo: "wizard-field-subtitulo",
  fieldDescripcion: "wizard-field-descripcion",
  fieldImagen: "wizard-field-imagen",
  fieldGaleria: "wizard-field-galeria",
  fieldFecha: "wizard-field-fecha",
  fieldHora: "wizard-field-hora",
  fieldSalon: "wizard-field-salon",
  fieldSalonOpcion: (s) => `wizard-field-salon-opcion-${s.toLowerCase().replace(/\s+/g, "-")}`,
  fieldSalonCheckbox: (s) => `wizard-field-salon-checkbox-${s.toLowerCase().replace(/\s+/g, "-")}`,
  fieldSalonCheckboxId: (s) => `wf-salon-cb-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`,
  fieldSalonHistorico: (s) => `wizard-field-salon-historico-${s.toLowerCase().replace(/\s+/g, "-")}`,
  fieldPrecioSalon: (s) => `wizard-field-precio-${s.toLowerCase().replace(/\s+/g, "-")}`,
  fieldTipoEvento: "wizard-field-tipo-evento",
  fieldEdadMinima: "wizard-field-edad-minima",
  fieldTipoAcceso: "wizard-field-tipo-acceso",
  btnGuardar: "wizard-btn-guardar",
  btnCancelar: "wizard-btn-cancelar",
  btnSiguiente: "wizard-btn-siguiente",
  btnAnterior: "wizard-btn-anterior",
  btnFinalizar: "wizard-btn-finalizar",
};

// Sprint 57 · F4A · Selector de modalidad + paso Salones y boletos (Acceso General)
export const EVENTO_MODALIDAD = {
  selector: "wizard-modalidad-selector",
  opcion: (m) => `wizard-modalidad-opcion-${m.toLowerCase()}`,
  bloqueado: "wizard-modalidad-bloqueado",
  aviso: "wizard-modalidad-aviso",
};

export const EVENTO_SALONES_AG = {
  screen: "wizard-salones-ag",
  vacio: "salones-ag-vacio",
  cargando: "salones-ag-cargando",
  btnAgregar: "salones-ag-btn-agregar",
  lista: "salones-ag-lista",
  row: (id) => `salones-ag-row-${id}`,
  rowNombre: (id) => `salones-ag-nombre-${id}`,
  rowCapacidad: (id) => `salones-ag-capacidad-${id}`,
  rowPrecio: (id) => `salones-ag-precio-${id}`,
  rowEstado: (id) => `salones-ag-estado-${id}`,
  btnGuardarRow: (id) => `salones-ag-guardar-${id}`,
  btnSubir: (id) => `salones-ag-subir-${id}`,
  btnBajar: (id) => `salones-ag-bajar-${id}`,
  btnActivar: (id) => `salones-ag-activar-${id}`,
  btnDesactivar: (id) => `salones-ag-desactivar-${id}`,
  btnEliminar: (id) => `salones-ag-eliminar-${id}`,
  rowError: (id) => `salones-ag-error-${id}`,
  notaPrecio: (id) => `salones-ag-nota-precio-${id}`,
  // Formulario de alta
  nuevoNombre: "salones-ag-nuevo-nombre",
  nuevoCapacidad: "salones-ag-nuevo-capacidad",
  nuevoPrecio: "salones-ag-nuevo-precio",
  nuevoGuardar: "salones-ag-nuevo-guardar",
  nuevoError: "salones-ag-nuevo-error",
  // Diálogo eliminar
  dialogEliminar: "salones-ag-dialog-eliminar",
  dialogEliminarConfirmar: "salones-ag-dialog-eliminar-confirmar",
  dialogEliminarDesactivar: "salones-ag-dialog-eliminar-desactivar",
  dialogEliminarCancelar: "salones-ag-dialog-eliminar-cancelar",
  // Resumen (Paso Venta)
  resumen: "salones-ag-resumen",
  resumenCapacidad: "salones-ag-resumen-capacidad",
};

export const EVENTO_CONFIG = {
  tipoAcceso: "config-tipo-acceso",
  tipoAccesoOpcion: (k) => `config-tipo-acceso-${k.toLowerCase()}`,
  edadMinima: "config-edad-minima",
  limiteBoletos: "config-limite-boletos",
  ventaInicioFecha: "config-venta-inicio-fecha",
  ventaInicioHora: "config-venta-inicio-hora",
  ventaCierreFecha: "config-venta-cierre-fecha",
  ventaCierreHora: "config-venta-cierre-hora",
  permitirPausarVenta: "config-permitir-pausar-venta",
  capacidadPlaceholder: "config-capacidad-placeholder",
  permitirListaEspera: "config-permitir-lista-espera",
  permitirReasignacionMesas: "config-permitir-reasignacion-mesas",
  permitirCambioNombres: "config-permitir-cambio-nombres",
  notifInicioVenta: "config-notif-inicio-venta",
  notifPausaVenta: "config-notif-pausa-venta",
  notifCambioSalon: "config-notif-cambio-salon",
  notifCambioMesa: "config-notif-cambio-mesa",
  notifCancelacion: "config-notif-cancelacion",
  resumen: "config-resumen",
};

export const EVENTO_PLANO = {
  container: "plano-container",
  canvas: "plano-canvas",
  salonActivo: "plano-salon-activo",
  capacidadTotal: "plano-capacidad-total",
  emptyMesas: "plano-empty-mesas",
  elementoFijo: (id) => `plano-elem-${id}`,
  mesa: (numero) => `plano-mesa-${numero}`,
  tipoMesa: "plano-form-tipo",
  capacidadMesa: "plano-form-capacidad",
  btnAgregar: "plano-btn-agregar",
  btnRenumerar: "plano-btn-renumerar",
  btnEliminar: "plano-btn-eliminar",
  panelSelected: "plano-panel-mesa",
  detNumero: "plano-det-numero",
  detTipo: "plano-det-tipo",
  detOrientacion: "plano-det-orientacion",
  detCapacidad: "plano-det-capacidad",
  detEstado: "plano-det-estado",
  detObservaciones: "plano-det-observaciones",
  // Selección múltiple
  seleccionCount: "plano-seleccion-count",
  btnSeleccionarTodas: "plano-btn-seleccionar-todas",
  btnDeseleccionar: "plano-btn-deseleccionar",
  bulkEstado: "plano-bulk-estado",
  bulkObservaciones: "plano-bulk-observaciones",
  bulkTipo: "plano-bulk-tipo",
  bulkCapacidad: "plano-bulk-capacidad",
  bulkAplicar: "plano-bulk-aplicar",
  duplicadoError: "plano-duplicado-error",
};

export const EVENTO_PUB = {
  checklist: "pub-checklist",
  check: (id) => `pub-check-${id}`,
  checkGoto: (id) => `pub-check-goto-${id}`,
  resumen: "pub-resumen",
  btnPreview: "pub-btn-preview",
  btnPublicar: "pub-btn-publicar",
  btnConfirmarPublicar: "pub-btn-confirmar",
  previewDialog: "pub-preview-dialog",
  previewCard: "pub-preview-card",
  previewBtnComprar: "pub-preview-btn-comprar",
  previewClose: "pub-preview-close",
  confirmDialog: "pub-confirm-dialog",
  notifRadio: "pub-notif-radio",
  notifSi: "pub-notif-si",
  notifNo: "pub-notif-no",
};

export const EVENTOS_ACCIONES = {
  publicarDialog: "eventos-dialog-publicar",
  publicarConfirm: "eventos-dialog-publicar-confirm",
  duplicarDialog: "eventos-dialog-duplicar",
  duplicarConfirm: "eventos-dialog-duplicar-confirm",
  cancelarDialog: "eventos-dialog-cancelar",
  cancelarMotivo: "eventos-dialog-cancelar-motivo",
  cancelarConfirm: "eventos-dialog-cancelar-confirm",
  cerrarDialog: "eventos-dialog-cerrar",
  cerrarMotivo: "eventos-dialog-cerrar-motivo",
  cerrarConfirm: "eventos-dialog-cerrar-confirm",
  pausarDialog: "eventos-dialog-pausar",
  pausarConfirm: "eventos-dialog-pausar-confirm",
  reanudarDialog: "eventos-dialog-reanudar",
  reanudarConfirm: "eventos-dialog-reanudar-confirm",
};

export const EVENTO_VENTA = {
  screen: "screen-evento-venta",
  precioSalon: (salon) => `venta-precio-${salon.toLowerCase().replace(/\s+/g, "-")}`,
  capacidadTotal: "venta-capacidad-total",
  capacidadDisponible: "venta-capacidad-disponible",
  capacidadReservada: "venta-capacidad-reservada",
  capacidadProtocolo: "venta-capacidad-protocolo",
  capacidadBloqueada: "venta-capacidad-bloqueada",
  mesasPorEstado: (estado) => `venta-mesas-${estado.toLowerCase()}`,
  btnAdministrarMesas: "venta-btn-administrar-mesas",
  btnEditarReglas: "venta-btn-editar-reglas",
  btnEditarVenta: "venta-btn-editar-venta",
  rlTipoAcceso: "venta-rl-tipo-acceso",
  rlEdadMinima: "venta-rl-edad-minima",
  rlLimiteBoletos: "venta-rl-limite-boletos",
  rlInicioVenta: "venta-rl-inicio",
  rlCierreVenta: "venta-rl-cierre",
  resumen: "venta-resumen",
  errorPrecios: "venta-error-precios",
  errorCapacidad: "venta-error-capacidad",
};

export const SCREENS = {
  inicio: "screen-inicio",
  misBoletos: "screen-mis-boletos",
  miPerfil: "screen-mi-perfil",
  adminDashboard: "screen-admin-dashboard",
  adminEventos: "screen-admin-eventos",
  adminUsuarios: "screen-admin-usuarios",
  adminNotificaciones: "screen-admin-notificaciones",
  adminBitacora: "screen-admin-bitacora",
  adminConfiguracion: "screen-admin-configuracion",
  adminReportes: "screen-admin-reportes",
};

// Sprint 47 · Portal de Recepción (login dedicado + testids KPIs)
export const RECEPCION_LOGIN = {
  screen: "screen-recepcion-login",
  inputUsuario: "recepcion-login-usuario",
  inputPassword: "recepcion-login-password",
  btnEntrar: "recepcion-login-entrar",
  error: "recepcion-login-error",
  avisoSesion: "recepcion-login-aviso-sesion",
};

export const DASHBOARD_KPIS = {
  ventaInicia: "dashboard-venta-inicia-hoy",
  ventaTermina: "dashboard-venta-termina-hoy",
  boletosPendientes: "dashboard-boletos-pendientes",
  accesosHoy: "dashboard-accesos-hoy",
  eventosProximos: "dashboard-eventos-proximos",
  alertas: "dashboard-alertas",
  errorCarga: "dashboard-kpis-error",
};
export const SALUD_PADRON = {
  card: "admin-dashboard-salud-padron",
  estadoBadge: "salud-padron-estado",
  btnRefrescar: "salud-padron-refrescar",
  btnDetalle: "salud-padron-btn-detalle",
  totalSocios: "salud-padron-total-socios",
  sociosActivos: "salud-padron-socios-activos",
  sociosBloqueados: "salud-padron-socios-bloqueados",
  fechaUltima: "salud-padron-fecha-ultima",
  tiempoTranscurrido: "salud-padron-tiempo-transcurrido",
  warnDesactualizada: "salud-padron-warn-desactualizada",
  sinSync: "salud-padron-sin-sync",
  contProcesados: "salud-padron-cont-procesados",
  contAltas: "salud-padron-cont-altas",
  contActualizados: "salud-padron-cont-actualizados",
  contBloqueos: "salud-padron-cont-bloqueos",
  contErrores: "salud-padron-cont-errores",
  motivo: "salud-padron-motivo",
  errorMsg: "salud-padron-error",
};

export const EVENTO_DETALLE = {
  screen: "screen-evento-detalle",
  btnRegresar: "evento-detalle-btn-regresar",
  nombre: "evento-detalle-nombre",
  fecha: "evento-detalle-fecha",
  hora: "evento-detalle-hora",
  salon: "evento-detalle-salon",
  precio: "evento-detalle-precio",
  preciosList: "evento-detalle-precios-list",
  estado: "evento-detalle-estado",
  btnComprar: "evento-detalle-btn-comprar",
  descripcion: "evento-detalle-descripcion",
  vestimenta: "evento-detalle-vestimenta",
  informacion: "evento-detalle-informacion",
  compartir: "evento-detalle-compartir",
  calendario: "evento-detalle-calendario",
};

export const COMPRA = {
  screen: "screen-compra-proximamente",
  btnRegresar: "compra-btn-regresar",
};

export const SMART_QUEUE = {
  screen: "screen-smart-queue",
  titulo: "smart-queue-titulo",
  posicion: "smart-queue-posicion",
  tiempoEstimado: "smart-queue-tiempo",
  mensaje: "smart-queue-mensaje",
  btnSalir: "smart-queue-btn-salir",
  btnContinuar: "smart-queue-btn-continuar",
};

export const SELECCION_MESA = {
  screen: "screen-seleccion-mesa",
  emptyMesas: "seleccion-mesa-empty",
  mesa: (n) => `mesa-${n}`,
  modal: "modal-mesa",
  modalMesa: "modal-mesa-numero",
  modalCapacidad: "modal-mesa-capacidad",
  modalDisponibles: "modal-mesa-disponibles",
  cantidad: "modal-cantidad",
  btnMenos: "modal-btn-menos",
  btnMas: "modal-btn-mas",
  modalPrecio: "modal-precio",
  modalTotal: "modal-total",
  btnCancelar: "modal-btn-cancelar",
  btnContinuar: "modal-btn-continuar",
  cupoRestante: "seleccion-mesa-cupo",
  limiteBloqueado: "seleccion-mesa-limite-bloqueado",
  btnVolverEvento: "seleccion-mesa-btn-volver-evento",
  btnMisBoletos: "seleccion-mesa-btn-mis-boletos",
};

export const RESUMEN = {
  screen: "screen-resumen-compra",
  evento: "resumen-evento",
  mesa: "resumen-mesa",
  cantidad: "resumen-cantidad",
  precio: "resumen-precio",
  total: "resumen-total",
  btnPago: "resumen-btn-pago",
  btnCambiar: "resumen-btn-cambiar-mesa",
};

export const PAGO = {
  screen: "screen-pago",
  btnRegresar: "pago-btn-regresar",
  recap: "pago-recap",
  total: "pago-total",
  simulador: "pago-simulador",
  simuladorOpcion: (id) => `pago-simulador-${id}`,
  btnPagar: "pago-btn-pagar",
  procesando: "pago-procesando",
  procesandoEstado: "pago-procesando-estado",
  msgRechazado: "pago-msg-rechazado",
  msgError: "pago-msg-error",
  msgCancelado: "pago-msg-cancelado",
  msgExpirado: "pago-msg-expirado",
  msgFallido: "pago-msg-fallido",
  btnReintentar: "pago-btn-reintentar",
  btnVolverEventos: "pago-btn-volver-eventos",
  msgLimite: "pago-msg-limite",
  msgNoReintentable: "pago-msg-no-reintentable",
  btnVolverEvento: "pago-btn-volver-evento",
  btnMisBoletos: "pago-btn-mis-boletos",
};

// Sprint 57 · F4B · Selección multisalón Acceso General + resumen + pago único
export const ACCESO_GENERAL = {
  screen: "screen-acceso-general",
  cargando: "ag-cargando",
  btnRegresar: "ag-btn-regresar",
  cupoRestante: "ag-cupo-restante",
  limiteBloqueado: "ag-limite-bloqueado",
  ventaPausada: "ag-venta-pausada",
  lista: "ag-lista-salones",
  salonRow: (id) => `ag-salon-${id}`,
  salonAgotado: (id) => `ag-salon-agotado-${id}`,
  salonDisponibles: (id) => `ag-salon-disponibles-${id}`,
  salonSubtotal: (id) => `ag-salon-subtotal-${id}`,
  btnMenos: (id) => `ag-salon-menos-${id}`,
  btnMas: (id) => `ag-salon-mas-${id}`,
  cantidad: (id) => `ag-salon-cantidad-${id}`,
  totalBoletos: "ag-total-boletos",
  totalGeneral: "ag-total-general",
  btnContinuar: "ag-btn-continuar",
  avisoRegion: "ag-aviso-region",
  // Resumen (carrito)
  resumen: "ag-resumen",
  resumenItem: (id) => `ag-resumen-item-${id}`,
  resumenTotalBoletos: "ag-resumen-total-boletos",
  resumenTotal: "ag-resumen-total",
  btnConfirmar: "ag-btn-confirmar",
  btnEditar: "ag-btn-editar",
  // Salón afectado por cambio de disponibilidad
  salonAfectado: (id) => `ag-salon-afectado-${id}`,
  btnVolverEvento: "ag-btn-volver-evento",
  btnMisBoletos: "ag-btn-mis-boletos",
};

// Pago único · desglose por salón (Acceso General)
export const PAGO_AG = {
  desglose: "pago-ag-desglose",
  item: (id) => `pago-ag-item-${id}`,
  modalidad: "pago-ag-modalidad",
  totalBoletos: "pago-ag-total-boletos",
};


export const COMPRA_CONFIRMADA = {
  screen: "screen-compra-confirmada",
  cargando: "compra-confirmada-cargando",
  recap: "compra-confirmada-recap",
  referencia: "compra-confirmada-referencia",
  total: "compra-confirmada-total",
  sandbox: "compra-confirmada-sandbox",
  // Sprint 54 · Fase A: se eliminaron los modales; acciones como botones.
  btnComprarMas: "compra-confirmada-btn-comprar-mas",
  btnTerminarAsignar: "compra-confirmada-btn-terminar-asignar",
};

export const MIS_BOLETOS = {
  emptyState: "mis-boletos-empty",
  btnVerEventos: "mis-boletos-btn-ver-eventos",
  list: "mis-boletos-list",
  item: "mis-boletos-item",
  itemPending: "mis-boletos-item-pending",
  // Sprint 54 · Fase A: agrupación por evento (una tarjeta por eventoId).
  eventoCard: (id) => `mis-boletos-evento-${id}`,
  eventoNombre: (id) => `mis-boletos-evento-nombre-${id}`,
  eventoSalones: (id) => `mis-boletos-evento-salones-${id}`,
  eventoTotalBoletos: (id) => `mis-boletos-evento-total-boletos-${id}`,
  eventoTotalPagado: (id) => `mis-boletos-evento-total-pagado-${id}`,
  eventoAsignados: (id) => `mis-boletos-evento-asignados-${id}`,
  eventoPendientes: (id) => `mis-boletos-evento-pendientes-${id}`,
  btnAdministrar: (id) => `mis-boletos-administrar-${id}`,
  btnVerDetalles: (id) => `mis-boletos-detalles-${id}`,
};

export const DETALLE_COMPRAS = {
  screen: "screen-detalle-compras",
  btnRegresar: "detalle-compras-btn-regresar",
  nombre: "detalle-compras-nombre",
  totalBoletos: "detalle-compras-total-boletos",
  totalPagado: "detalle-compras-total-pagado",
  list: "detalle-compras-list",
  item: (id) => `detalle-compras-item-${id}`,
  itemMesa: (id) => `detalle-compras-mesa-${id}`,
  itemSalon: (id) => `detalle-compras-salon-${id}`,
  itemCantidad: (id) => `detalle-compras-cantidad-${id}`,
  boletos: (id) => `detalle-compras-boletos-${id}`,
  boleto: (bid) => `detalle-boleto-${bid}`,
  boletoAsistente: (bid) => `detalle-boleto-asistente-${bid}`,
  boletoUbicacion: (bid) => `detalle-boleto-ubicacion-${bid}`,
  boletoEstado: (bid) => `detalle-boleto-estado-${bid}`,
  itemTotal: (id) => `detalle-compras-total-${id}`,
  itemReferencia: (id) => `detalle-compras-referencia-${id}`,
  itemAsignar: (id) => `detalle-compras-asignar-${id}`,
  btnAdministrarTodo: "detalle-compras-administrar-todo",
};

export const ASIGNAR = {
  screen: "screen-asignar-asistentes",
  btnRegresar: "asignar-btn-regresar",
  info: "asignar-info",
  resumen: "asignar-resumen",
  resumenTotal: "asignar-resumen-total",
  resumenAsignados: "asignar-resumen-asignados",
  resumenPendientes: "asignar-resumen-pendientes",
  warnRepetidos: "asignar-warn-repetidos",
  item: (n) => `asignar-boleto-${n}`,
  itemNombre: (n) => `asignar-boleto-nombre-${n}`,
  itemPendiente: (n) => `asignar-boleto-pendiente-${n}`,
  inputNombre: (n) => `asignar-input-nombre-${n}`,
  btnUsarMisDatos: (n) => `asignar-btn-usar-datos-${n}`,
  btnVerBoleto: (n) => `asignar-btn-ver-boleto-${n}`,
  msgValidado: (n) => `asignar-msg-validado-${n}`,
  itemUtilizado: (n) => `asignar-boleto-utilizado-${n}`,
  itemPorConfirmar: (n) => `asignar-boleto-por-confirmar-${n}`,
  msgPorConfirmar: (n) => `asignar-msg-por-confirmar-${n}`,
  btnReintentarBoleto: (n) => `asignar-btn-reintentar-boleto-${n}`,
  verificando: "asignar-verificando",
  verificacionError: "asignar-verificacion-error",
  btnReintentarVerificacion: "asignar-btn-reintentar-verificacion",
  btnRegresarVerificacion: "asignar-btn-regresar-verificacion",
  itemSinGuardar: (n) => `asignar-boleto-sin-guardar-${n}`,
  btnGuardarCambios: "asignar-btn-guardar-cambios",
  dialogSalirScreen: "asignar-dialog-salir",
  dialogSalirConfirmar: "asignar-dialog-salir-confirmar",
  dialogSalirCancelar: "asignar-dialog-salir-cancelar",
};

export const APP_TOPBAR = {
  btnLogout: "app-topbar-btn-logout",
};

export const BOLETO = {
  screen: "screen-boleto-digital",
  btnRegresar: "boleto-btn-regresar",
  fecha: "boleto-fecha",
  hora: "boleto-hora",
  salon: "boleto-salon",
  mesa: "boleto-mesa",
  asistente: "boleto-asistente",
  qr: "boleto-qr",
  msgValidado: "boleto-msg-validado",
};

export const BRAND = {
  mark: "ct-brand-mark",
  wordmark: "ct-brand-wordmark",
};

export const ADMIN = {
  sidebar: "admin-sidebar",
  mobileToggle: "admin-mobile-toggle",
  topbar: "admin-topbar",
  headerScreenName: "admin-header-screen-name",
  headerUserName: "admin-header-user-name",
  headerUserRole: "admin-header-user-role",
  btnLogout: "admin-btn-logout",
};

export const RECEPCION = {
  // Layout / brand
  layout: "recepcion-layout",
  layoutVerificando: "recepcion-layout-verificando",
  layoutErrorVerificacion: "recepcion-layout-error-verificacion",
  layoutReintentar: "recepcion-layout-reintentar",
  brand: "recepcion-brand",
  linkSalir: "recepcion-link-salir",

  // Selección de evento
  seleccionScreen: "recepcion-seleccion-screen",
  seleccionEmpty: "recepcion-seleccion-empty",
  seleccionLoading: "recepcion-seleccion-loading",
  seleccionError: "recepcion-seleccion-error",
  seleccionErrorCodigo: "recepcion-seleccion-error-codigo",
  seleccionReintentar: "recepcion-seleccion-reintentar",
  seleccionRelogin: "recepcion-seleccion-relogin",
  seleccionList: "recepcion-seleccion-list",
  seleccionItem: (id) => `recepcion-evento-${id}`,

  // Escáner
  escanerScreen: "recepcion-escaner-screen",
  eventoActivo: "recepcion-evento-activo",
  btnCambiarEvento: "recepcion-btn-cambiar-evento",
  scannerContainer: "recepcion-scanner-container",
  btnStartCamera: "recepcion-btn-start-camera",
  btnStopCamera: "recepcion-btn-stop-camera",
  cameraSelect: "recepcion-camera-select",
  cameraOption: (id) => `recepcion-camera-option-${id}`,
  cameraOptionAuto: "recepcion-camera-option-auto",
  resultadoSlot: "recepcion-resultado-slot",
  cameraEstado: "recepcion-camera-estado",
  cameraVerificando: "recepcion-camera-verificando",
  cameraError: "recepcion-camera-error",
  cameraDetalle: "recepcion-camera-detalle",
  cameraAviso: "recepcion-camera-aviso",
  btnReintentarCamera: "recepcion-btn-reintentar-camera",
  simInput: "recepcion-sim-input",
  btnSimular: "recepcion-btn-simular",
  btnBusquedaManual: "recepcion-btn-busqueda-manual",
  busquedaInput: "recepcion-busqueda-input",
  busquedaResultados: "recepcion-busqueda-resultados",
  busquedaItem: (id) => `recepcion-busqueda-item-${id}`,
  btnValidarManual: (id) => `recepcion-btn-validar-manual-${id}`,
  contadorSesion: "recepcion-contador-sesion",
  contadorListos: "recepcion-contador-listos",
  contadorValidados: "recepcion-contador-validados",
  contadorRechazos: "recepcion-contador-rechazos",
  contadorManuales: "recepcion-contador-manuales",

  // Bitácora de accesos (en pantalla)
  bitacoraSection: "recepcion-bitacora-section",
  bitacoraRefresh: "recepcion-bitacora-refresh",
  bitacoraLista: "recepcion-bitacora-lista",
  bitacoraVacia: "recepcion-bitacora-vacia",
  bitacoraItem: (id) => `recepcion-bitacora-item-${id}`,

  // Flash de resultado
  flashOk: "recepcion-flash-ok",
  flashAdvertencia: "recepcion-flash-advertencia",
  flashRechazado: "recepcion-flash-rechazado",
  flashMotivo: "recepcion-flash-motivo",
  flashAsistente: "recepcion-flash-asistente",
  btnCerrarFlash: "recepcion-btn-cerrar-flash",
  flashCuenta: "recepcion-flash-cuenta",
  btnForzarValidacion: "recepcion-btn-forzar-validacion",
};

/* -------------------- Sprint 58 · F2 · Plantillas de mesas -------------------- */
export const PLANTILLAS_MESAS = {
  screen: "plantillas-mesas-screen",
  denied: "plantillas-mesas-denied",
  btnNueva: "plantillas-mesas-btn-nueva",
  buscarInput: "plantillas-mesas-buscar-input",
  filtroSalon: "plantillas-mesas-filtro-salon",
  filtroEstado: "plantillas-mesas-filtro-estado",
  lista: "plantillas-mesas-lista",
  vacia: "plantillas-mesas-vacia",
  item: (id) => `plantillas-mesas-item-${id}`,
  itemEstado: (id) => `plantillas-mesas-item-estado-${id}`,
  btnEditar: (id) => `plantillas-mesas-btn-editar-${id}`,
  btnActivar: (id) => `plantillas-mesas-btn-activar-${id}`,
  btnDesactivar: (id) => `plantillas-mesas-btn-desactivar-${id}`,
  btnEliminar: (id) => `plantillas-mesas-btn-eliminar-${id}`,
  confirmEliminar: "plantillas-mesas-confirm-eliminar",
  confirmEliminarOk: "plantillas-mesas-confirm-eliminar-ok",
  confirmEliminarCancel: "plantillas-mesas-confirm-eliminar-cancel",
  // Editor
  editorScreen: "plantilla-editor-screen",
  editorNombre: "plantilla-editor-nombre",
  editorSalon: "plantilla-editor-salon",
  editorResumen: "plantilla-editor-resumen",
  editorGuardar: "plantilla-editor-guardar",
  editorCancelar: "plantilla-editor-cancelar",
  editorError: "plantilla-editor-error",
  editorConfirmSalir: "plantilla-editor-confirm-salir",
  editorConfirmSalirOk: "plantilla-editor-confirm-salir-ok",
  editorConfirmSalirCancel: "plantilla-editor-confirm-salir-cancel",
};

export const WIZARD_PLANTILLA = {
  seccion: "wizard-plantilla-seccion",
  abrir: "wizard-plantilla-abrir",
  lista: "wizard-plantilla-lista",
  item: (id) => `wizard-plantilla-item-${id}`,
  aplicar: (id) => `wizard-plantilla-aplicar-${id}`,
  confirm: "wizard-plantilla-confirm",
  confirmOk: "wizard-plantilla-confirm-ok",
  confirmCancel: "wizard-plantilla-confirm-cancel",
  avisoPrecios: "wizard-plantilla-aviso-precios",
  error: "wizard-plantilla-error",
};
